import navbarMobile from '../../assets/setup/navbar_mobile.png';
import navbarDesktop from '../../assets/setup/navbar_desktop.png';
import swipeDecks from '../../assets/setup/tutorial_swipe_decks.png';
import returnDeckList from '../../assets/setup/tutorial_return_decklist.png'

export const DeckNavigation: React.FC = () => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p> There are multiple ways to navigate between decks while inside a deck. You can use the navigation bar (if persistent navigation is enabled in Settings), or use other methods and keep the navigation bar hidden.</p>
            {/* Mobile Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Mobile</h2>
                <ul className="list-disc list-inside">
                    <li>Use the navigation bar to switch between decks, or return to the deck list screen.
                        <img className="mt-2 mb-3" src={navbarMobile} alt="Navbar on mobile" width="400px" />
                    </li>
                    <li>Switch to 'Settings Mode' mode by tapping the eye icon on the navigation bar or by tapping the floating Hopper button. Then, swipe up or down to navigate between decks. (not applicable on iOS) 
                        <img className="mt-2 mb-3" src={swipeDecks} alt="Swipe between decks" width="300" />
                    </li>
                    <li>Swipe back, or use the back button to return to the deck list screen. (not applicable on iOS) 
                        <img className="mt-2 mb-3" src={returnDeckList} alt="Return to deck list" width="300" />
                    </li>
                </ul>
            </div>

            {/* Desktop Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Desktop</h2>
                <ul className="list-disc list-inside">
                    <li>Use the navigation menu if persistent navigation is enabled to switch between decks.
                        <img className="mt-2 mb-3" src={navbarDesktop} alt="Navbar on desktop" width="600px" />

                    </li>
                    <li>Press backspace or right-click and select 'Exit Deck' to return to the deck list screen.</li>
                    <li>Use the mouse scroll wheel or press the up or down arrow keys to navigate between decks while inside a deck.</li>
                </ul>
            </div>

            {/* Shared Instruction */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">SAMMI Core</h2>
                <ul className="list-disc list-inside">
                    <li>Use the <a href="https://sammi.solutions/docs/commands/308" className="text-blue-500 underline">Deck App: Switch Deck</a> command in SAMMI Core to switch between decks programmatically.</li>
                </ul>
            </div>
        </div>
    );
};
